var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    className: "_127U0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14623",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2287",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14622",
    transform: "translate(2 2)",
    fill: "#003574"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2274",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(10.75 10.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2275",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(10.75 5)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2276",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(10.75 16.5)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5687",
    fill: "none",
    d: "M-6-6h40v40H-6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots2);
export default __webpack_public_path__ + "static/media/dots2.09e97aa693c3e18dcca4f629dfe755e1.svg";
export { ForwardRef as ReactComponent };